const unitOptimizerOverviewHu = {
	unitOptimizerOverviewTable: 'Unit Optimizer Overview',
	timestamp: 'Timestamp',
	tag: 'Tag',
	objective: 'Objective',
	state: 'State',
	name: 'Name',
};

export default unitOptimizerOverviewHu;
